// import { useState, useEffect } from 'react';
// import {
//     getUsersList,
//     getRolesDropdown,
//     getStudiesDropdown,
//     getSitesDropdown,
//     createUser,
//     updateUser,
//     deleteUser,
//     getUserHistory
// } from '../../../Config/api';

// export const useUserManagement = () => {
//     const [users, setUsers] = useState([]);
//     const [roles, setRoles] = useState([]);
//     const [studies, setStudies] = useState([]);
//     const [sites, setSites] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(25);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [confirmModal, setConfirmModal] = useState({
//         show: false,
//         title: '',
//         message: '',
//         type: 'info',
//         confirmText: 'OK',
//         cancelText: 'Cancel',
//         onConfirm: null,
//         onCancel: null
//     });

//     const getCurrentUser = () => {
//         const userStr = localStorage.getItem('user');
//         return userStr ? JSON.parse(userStr) : null;
//     };

//     const fetchUsers = async () => {
//         try {
//             setLoading(true);
//             const data = await getUsersList({
//                 page: currentPage,
//                 limit: rowsPerPage,
//                 search: searchTerm
//             });

//             if (data.success) {
//                 setUsers(data.data);
//                 setTotalPages(data.pagination.totalPages);
//                 setTotalRecords(data.pagination.totalRecords);
//             }
//         } catch (error) {
//             setConfirmModal({
//                 show: true,
//                 title: 'Error',
//                 message: error.message || 'Failed to fetch users',
//                 type: 'error',
//                 onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchRoles = async () => {
//         try {
//             const data = await getRolesDropdown();
//             if (data.success) {
//                 setRoles(data.data);
//             }
//         } catch (error) {
//             console.error('Error fetching roles:', error);
//         }
//     };

//     const fetchStudies = async () => {
//         try {
//             const data = await getStudiesDropdown();
//             if (data.success) {
//                 setStudies(data.data || []);
//             }
//         } catch (error) {
//             console.error('Error fetching studies:', error);
//             setStudies([]);
//         }
//     };

//     const fetchSites = async () => {
//         try {
//             const data = await getSitesDropdown();
//             if (data.success) {
//                 setSites(data.data || []);
//             }
//         } catch (error) {
//             console.error('Error fetching sites:', error);
//             setSites([]);
//         }
//     };

//     const handleCreateUser = async (formData) => {
//         try {
//             const currentUser = getCurrentUser();

//             const isPrincipalInvestigator = formData.assigned_sites && formData.assigned_sites.length > 0;

//             let study_id = null;
//             let site_id = null;

//             if (isPrincipalInvestigator) {
//                 study_id = formData.assigned_sites[0]?.study_id ? parseInt(formData.assigned_sites[0].study_id) : null;
//                 site_id = formData.assigned_sites[0]?.site_id ? parseInt(formData.assigned_sites[0].site_id) : null;
//             } else {
//                 study_id = formData.study_id ? parseInt(formData.study_id) : null;
//                 site_id = formData.site_id ? parseInt(formData.site_id) : null;
//             }

//             const data = await createUser({
//                 full_name: formData.full_name,
//                 email_address: formData.email_address,
//                 contact_number: formData.contact_number,
//                 role_id: parseInt(formData.role_id),
//                 study_id: study_id,
//                 site_id: site_id,
//                 status: formData.status,
//                 assigned_sites: formData.assigned_sites || [],
//                 created_by: currentUser?.userId || currentUser?.user_id
//             });

//             if (data.success) {
//                 await fetchUsers();
//                 setConfirmModal({
//                     show: true,
//                     title: 'Success!',
//                     message: 'User created successfully!',
//                     type: 'success',
//                     onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//                 });
//                 return { success: true };
//             }
//         } catch (error) {
//             setConfirmModal({
//                 show: true,
//                 title: 'Error',
//                 message: error.message || 'Failed to create user',
//                 type: 'error',
//                 onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//             });
//             return { success: false };
//         }
//     };

//     const handleUpdateUser = async (userId, formData) => {
//         try {
//             const currentUser = getCurrentUser();

//             const isPrincipalInvestigator = formData.assigned_sites && formData.assigned_sites.length > 0;

//             let study_id = null;
//             let site_id = null;

//             if (isPrincipalInvestigator) {
//                 study_id = formData.assigned_sites[0]?.study_id ? parseInt(formData.assigned_sites[0].study_id) : null;
//                 site_id = formData.assigned_sites[0]?.site_id ? parseInt(formData.assigned_sites[0].site_id) : null;
//             } else {
//                 study_id = formData.study_id ? parseInt(formData.study_id) : null;
//                 site_id = formData.site_id ? parseInt(formData.site_id) : null;
//             }

//             const data = await updateUser(userId, {
//                 full_name: formData.full_name,
//                 email_address: formData.email_address,
//                 contact_number: formData.contact_number,
//                 role_id: parseInt(formData.role_id),
//                 study_id: study_id,
//                 site_id: site_id,
//                 status: formData.status,
//                 assigned_sites: formData.assigned_sites || [],
//                 updated_by: currentUser?.userId || currentUser?.user_id
//             });

//             if (data.success) {
//                 await fetchUsers();
//                 setConfirmModal({
//                     show: true,
//                     title: 'Success!',
//                     message: 'User updated successfully!',
//                     type: 'success',
//                     onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//                 });
//                 return { success: true };
//             }
//         } catch (error) {
//             setConfirmModal({
//                 show: true,
//                 title: 'Error',
//                 message: error.message || 'Failed to update user',
//                 type: 'error',
//                 onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//             });
//             return { success: false };
//         }
//     };

//     const handleDeleteUser = async (user) => {
//         try {
//             const currentUser = getCurrentUser();
//             const data = await deleteUser(user.user_id, currentUser?.userId || currentUser?.user_id);

//             if (data.success) {
//                 await fetchUsers();
//                 setConfirmModal({
//                     show: true,
//                     title: 'Deleted!',
//                     message: 'User has been permanently deleted.',
//                     type: 'success',
//                     onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//                 });
//             }
//         } catch (error) {
//             setConfirmModal({
//                 show: true,
//                 title: 'Error',
//                 message: error.message || 'Failed to delete user',
//                 type: 'error',
//                 onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
//             });
//         }
//     };

//     const fetchUserHistory = async (userId) => {
//         try {
//             const data = await getUserHistory(userId);
//             if (data.success) {
//                 return data.data;
//             }
//             return [];
//         } catch (error) {
//             console.error('Error fetching user history:', error);
//             return [];
//         }
//     };

//     useEffect(() => {
//         let isMounted = true;
//         const loadData = async () => {
//             if (isMounted) {
//                 await Promise.allSettled([fetchUsers(), fetchRoles(), fetchStudies(), fetchSites()]);
//             }
//         };
//         loadData();
//         return () => { isMounted = false; };
//     }, [searchTerm, currentPage, rowsPerPage]);

//     return {
//         users,
//         roles,
//         studies,
//         sites,
//         searchTerm,
//         setSearchTerm,
//         currentPage,
//         setCurrentPage,
//         rowsPerPage,
//         setRowsPerPage,
//         totalPages,
//         totalRecords,
//         loading,
//         confirmModal,
//         setConfirmModal,
//         handleCreateUser,
//         handleUpdateUser,
//         handleDeleteUser,
//         fetchUserHistory
//     };
// };

import { useState, useEffect } from 'react';
import {
    getUsersList,
    getRolesDropdown,
    getStudiesDropdown,
    getSitesDropdown,
    createUser,
    updateUser,
    deleteUser,
    getUserHistory,
    consentDropdown
} from '../../../Config/api';

export const useUserManagement = () => {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [studies, setStudies] = useState([]);
    const [sites, setSites] = useState([]);
    const [consentTemplates, setConsentTemplates] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState({
        show: false,
        title: '',
        message: '',
        type: 'info',
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: null,
        onCancel: null
    });

    const getCurrentUser = () => {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    };

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const data = await getUsersList({
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm
            });

            if (data.success) {
                setUsers(data.data);
                setTotalPages(data.pagination.totalPages);
                setTotalRecords(data.pagination.totalRecords);
            }
        } catch (error) {
            setConfirmModal({
                show: true,
                title: 'Error',
                message: error.message || 'Failed to fetch users',
                type: 'error',
                onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchRoles = async () => {
        try {
            const data = await getRolesDropdown();
            if (data.success) {
                setRoles(data.data);
            }
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const fetchStudies = async () => {
        try {
            const data = await getStudiesDropdown();
            if (data.success) {
                setStudies(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching studies:', error);
            setStudies([]);
        }
    };

    const fetchSites = async () => {
        try {
            const data = await getSitesDropdown();
            if (data.success) {
                setSites(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching sites:', error);
            setSites([]);
        }
    };

    const fetchConsentTemplates = async () => {
        try {
            const data = await consentDropdown();
            if (data.status === 'success') {
                setConsentTemplates(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching consent templates:', error);
            setConsentTemplates([]);
        }
    };


    const handleCreateUser = async (formData) => {
        try {
            const currentUser = getCurrentUser();

            const isPrincipalInvestigator = formData.assigned_sites && formData.assigned_sites.length > 0;

            let study_id = null;
            let site_id = null;

            if (isPrincipalInvestigator) {
                study_id = formData.assigned_sites[0]?.study_id ? parseInt(formData.assigned_sites[0].study_id) : null;
                site_id = formData.assigned_sites[0]?.site_id ? parseInt(formData.assigned_sites[0].site_id) : null;
            } else {
                study_id = formData.study_id ? parseInt(formData.study_id) : null;
                site_id = formData.site_id ? parseInt(formData.site_id) : null;
            }

            const data = await createUser({
                full_name: formData.full_name,
                email_address: formData.email_address,
                contact_number: formData.contact_number,
                role_id: parseInt(formData.role_id),
                study_id: study_id,
                site_id: site_id,
                status: formData.status,
                assigned_sites: formData.assigned_sites || [],
                created_by: currentUser?.userId || currentUser?.user_id
            });

            if (data.success) {
                await Promise.all([
                    fetchUsers(),
                    fetchRoles(),
                    fetchStudies(),
                    fetchSites(),
                    fetchConsentTemplates()
                ]);
                setConfirmModal({
                    show: true,
                    title: 'Success!',
                    message: 'User created successfully!',
                    type: 'success',
                    onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
                });
                return { success: true };
            }
        } catch (error) {
            setConfirmModal({
                show: true,
                title: 'Error',
                message: error.message || 'Failed to create user',
                type: 'error',
                onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
            });
            return { success: false };
        }
    };

    // const handleUpdateUser = async (userId, formData) => {
    //     try {
    //         const currentUser = getCurrentUser();

    //         const isPrincipalInvestigator = formData.assigned_sites && formData.assigned_sites.length > 0;

    //         let study_id = null;
    //         let site_id = null;

    //         if (isPrincipalInvestigator) {
    //             study_id = formData.assigned_sites[0]?.study_id ? parseInt(formData.assigned_sites[0].study_id) : null;
    //             site_id = formData.assigned_sites[0]?.site_id ? parseInt(formData.assigned_sites[0].site_id) : null;
    //         } else {
    //             study_id = formData.study_id ? parseInt(formData.study_id) : null;
    //             site_id = formData.site_id ? parseInt(formData.site_id) : null;
    //         }

    //         const data = await updateUser(userId, {
    //             full_name: formData.full_name,
    //             email_address: formData.email_address,
    //             contact_number: formData.contact_number,
    //             role_id: parseInt(formData.role_id),
    //             study_id: study_id,
    //             site_id: site_id,
    //             status: formData.status,
    //             assigned_sites: formData.assigned_sites || [],
    //             updated_by: currentUser?.userId || currentUser?.user_id
    //         });

    //         if (data.success) {
    //             await fetchUsers();
    //             setConfirmModal({
    //                 show: true,
    //                 title: 'Success!',
    //                 message: 'User updated successfully!',
    //                 type: 'success',
    //                 onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
    //             });
    //             return { success: true };
    //         }
    //     } catch (error) {
    //         setConfirmModal({
    //             show: true,
    //             title: 'Error',
    //             message: error.message || 'Failed to update user',
    //             type: 'error',
    //             onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
    //         });
    //         return { success: false };
    //     }
    // };

    const handleUpdateUser = async (userId, formData) => {
        try {
            const currentUser = getCurrentUser();

            const isPrincipalInvestigator = formData.assigned_sites && formData.assigned_sites.length > 0;

            let study_id = null;
            let site_id = null;

            if (isPrincipalInvestigator) {
                study_id = formData.assigned_sites[0]?.study_id ? parseInt(formData.assigned_sites[0].study_id) : null;
                site_id = formData.assigned_sites[0]?.site_id ? parseInt(formData.assigned_sites[0].site_id) : null;
            } else {
                study_id = formData.study_id ? parseInt(formData.study_id) : null;
                site_id = formData.site_id ? parseInt(formData.site_id) : null;
            }

            const data = await createUser({
                user_id: userId,
                full_name: formData.full_name,
                email_address: formData.email_address,
                contact_number: formData.contact_number,
                role_id: parseInt(formData.role_id),
                study_id: study_id,
                site_id: site_id,
                status: formData.status,
                assigned_sites: formData.assigned_sites || [],
                updated_by: currentUser?.userId || currentUser?.user_id
            });

            if (data.success) {
                await Promise.all([
                    fetchUsers(),
                    fetchRoles(),
                    fetchStudies(),
                    fetchSites(),
                    fetchConsentTemplates()
                ]);
                setConfirmModal({
                    show: true,
                    title: 'Success!',
                    message: 'User updated successfully!',
                    type: 'success',
                    onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
                });
                return { success: true };
            }
        } catch (error) {
            setConfirmModal({
                show: true,
                title: 'Error',
                message: error.message || 'Failed to update user',
                type: 'error',
                onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
            });
            return { success: false };
        }
    };
    const handleDeleteUser = async (user) => {
        try {
            const currentUser = getCurrentUser();
            const data = await deleteUser(user.user_id, currentUser?.userId || currentUser?.user_id);

            if (data.success) {
                await Promise.all([
                    fetchUsers(),
                    fetchRoles(),
                    fetchStudies(),
                    fetchSites(),
                    fetchConsentTemplates()
                ]);
                setConfirmModal({
                    show: true,
                    title: 'Deleted!',
                    message: 'User has been permanently deleted.',
                    type: 'success',
                    onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
                });
            }
        } catch (error) {
            setConfirmModal({
                show: true,
                title: 'Error',
                message: error.message || 'Failed to delete user',
                type: 'error',
                onConfirm: () => setConfirmModal(prev => ({ ...prev, show: false }))
            });
        }
    };

    const fetchUserHistory = async (userId) => {
        try {
            const data = await getUserHistory(userId);
            if (data.success) {
                return data.data;
            }
            return [];
        } catch (error) {
            console.error('Error fetching user history:', error);
            return [];
        }
    };

    useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            if (isMounted) {
                await Promise.allSettled([fetchUsers(), fetchRoles(), fetchStudies(), fetchSites(), fetchConsentTemplates()]);
            }
        };
        loadData();
        return () => { isMounted = false; };
    }, [searchTerm, currentPage, rowsPerPage]);

    return {
        users,
        roles,
        studies,
        sites,
        consentTemplates,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalPages,
        totalRecords,
        loading,
        confirmModal,
        setConfirmModal,
        handleCreateUser,
        handleUpdateUser,
        handleDeleteUser,
        fetchUserHistory
    };
};